import { render, staticRenderFns } from "./AiVoiceAgentCallStarter.vue?vue&type=template&id=8149279c&scoped=true"
import script from "./AiVoiceAgentCallStarter.vue?vue&type=script&lang=js"
export * from "./AiVoiceAgentCallStarter.vue?vue&type=script&lang=js"
import style0 from "./AiVoiceAgentCallStarter.vue?vue&type=style&index=0&id=8149279c&prod&lang=scss&scoped=true"
import style1 from "./AiVoiceAgentCallStarter.vue?vue&type=style&index=1&id=8149279c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8149279c",
  null
  
)

export default component.exports